import { render } from "./Candidatedetails.vue?vue&type=template&id=460fbcfe&scoped=true"
import script from "./Candidatedetails.vue?vue&type=script&lang=js"
export * from "./Candidatedetails.vue?vue&type=script&lang=js"

import "./Candidatedetails.vue?vue&type=style&index=0&id=460fbcfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460fbcfe"]])

export default __exports__